<template>
  <div style="text-align:left;">
    <div style="margin:30px;"><h3>研究项目名称：</h3>{{project.name}}</div>
    <div style="margin:30px;"><h3>方案编号：</h3>{{project.plan_number}}</div>
    <div style="margin:30px;"><h3>申办方机构：</h3>{{project.sponsor}}</div>
    <div style="margin:30px;"><h3>项目介绍：</h3>{{project.introduce}}</div>
    <div style="margin:30px;"><h3>知情同意书：</h3>{{project.informed_consent[0].name}}</div>
    <ProjectAddSS title="入选条件" :SS_data="project.SS_list"  :onlyShow="true" />
    <ProjectAddSS title="排除条件" :SS_data="project.SE_list" :onlyShow="true"/>
    <ProjectAddOtherInfo :otherInfoDataList="project.otherInfoDataList" :onlyShow="true" />

    <div style="margin:30px;"><h3>是否需要受试者录像阅读相关文字：</h3>{{project.need_video==="1"?"必须":"不必须"}}</div>
    <div style="margin:30px;"><h3>录像阅读文本：</h3>{{project.video_text}}</div>
    <!-- <div style="margin:30px;"><h3>更新项目版本是否需要重新签署知情同意书：</h3>{{project.m_flex_column}}</div> -->
    <div style="margin:30px;">
      <h3>已选单位：</h3>
      <a-table
        :columns="unit_columns"
        :data-source="project.unit_seleccted_list"
        bordered
        style="margin:30px;"
        :pagination="false"
      ></a-table>
    </div>

    <div style="margin:30px;">
       <h3>已选研究者：</h3>
      <ProjectAddDoctor  :doctor_list="project.doctor_list"  :onlyShow="true"/>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import ProjectAddShow from "@/components/ProjectAddShow";
import ProjectAddSS from "@/components/ProjectAddSS";
import ProjectAddOtherInfo from "@/components/ProjectAddOtherInfo";
import ProjectAddDoctor from "@/components/ProjectAddDoctor";


const unit_columns = [
  {
    title: "单位名称",
    dataIndex: "name",
    width: "80%",
  }
];
export default {
  name: "ProjectAddShow",
   components: {
    ProjectAddShow,
    ProjectAddSS,
    ProjectAddOtherInfo,
    ProjectAddDoctor
  },
  props: {
    project: Object
  },
   mounted() {
    console.log("获取当前project",this.project)
  },
  data() {
    return {
      unit_columns
    };
  }
};
</script>

<style>
</style>